module.exports = __webpack_public_path__ + "img/services.a8a4c36c.png";